import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

// The shared bordered "card" surface: a `bg-card` box with the subtle `ring-foreground/10` border and
// rounded-xl corners. Both the morphing onboarding box (<FlowFrame>, which layers the `flow-frame` /
// `flow-content` view-transition names on top) and the plain, non-morphing cards (the register choice
// tiles, the team-evaluation box) render this same surface, so their look can't drift apart. It replaces
// the trimmed shadcn <Card>: those usages only ever shared the surface, not its flex/gap/padding, so this
// owns just the surface and each consumer composes its own inner layout (padding, flex column, …).
export function Frame({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="frame"
      className={cn(
        'bg-card text-card-foreground ring-foreground/10 overflow-hidden rounded-xl py-4 text-sm ring-1',
        className,
      )}
      {...props}
    />
  )
}
